/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import { MENU_ITEM_DIVIDER, MENU_ITEM_ICON_DIVIDER, MENU_ITEM_WIDGET } from "src/libs/basic-view/ExtendMenu"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import Shortcode from "src/libs/useful/shortcode"
import { __ } from "src/libs/utilities"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { CardsContent, ICard, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { getAnimateDelay } from "../../../utils/getAnimateDelay"
import CardEditForm from "../../landing-edit/editors/cards/CardEditForm"
import CardBody from "./CardBody"
import CardOuter from "./CardOuter"
import CardTail from "./CardTail"

/* Protopia Ecosystem component */
export interface ICardProps {
    i?:number
    data: ICard
    section: ILandingSection
    contentData: CardsContent
    width?:number
}
const Card = ({data, section, contentData, ...props}: ICardProps): JSX.Element => {
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    const composition = useComposition(section, contentData) 

    const animated_delay = [
        SECTION_DESIGN_TYPE.FEED, 
        SECTION_DESIGN_TYPE.COLUMN, 
        SECTION_DESIGN_TYPE.VTIMELINE,
    ].includes(contentData.feedType) 
        ?
        getAnimateDelay(contentData.animated_delay, data.i)
        :
        1
    
    const ref = useRef(null)
    
    useAnimated( ref, animated_delay )
    const animate   = useAnimatedStyle( contentData, data.i )
    const columns = composition.columns
    const width     = useSyncState<string>( getCssDemention( props.width ? props.width : ( 100 / columns ) + "%", "350px") )
    const [height]  = useState<string>( getCssDemention(contentData.cards_height, "auto") )
    const [padding] = useState<string>( 
        getCssDemention(
            [ SECTION_DESIGN_TYPE.CAROUSEL, SECTION_DESIGN_TYPE.ACCORDEON ].includes( contentData.feedType )
                ?
                0
                :
                (contentData.gap || 0) / 2, 
            "0"
        ) 
    )
    
    useEffect(() => {
        width.set( 
            getCssDemention(
                typeof props.width === "number" ? props.width + "%" : ( 100 / columns ) + "%" , 
                "350px" 
            )
        )
        addCSSClass(
            `landing-card-${data.id}`,
            `.landing-card-${data.id} {
                max-width: ${ width.get() };
                max-height: ${ height };
                width: ${ width.get() };
                height: ${ height };
                padding:${ padding };
                z-index: ${data.i}; 
            }`
        ) 
        
        return () => { 
            removeCSSClass(`landing-card-${data.id}`)
        }
    },[ composition, contentData ])
    
    const _id: string = section.id.toString()
    const mainClass = ""
    const getContext = () => {
        if(!isEdit) return 
        const dtTitle = __( "Cards" ) 
        let context = [
            [
                `Section's settings${MENU_ITEM_ICON_DIVIDER}cog`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}compositionWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}carouselWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}columnWidget${MENU_ITEM_ICON_DIVIDER}${_id}.section`,
                `Title${MENU_ITEM_ICON_DIVIDER}header${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.title`,
                `Description${MENU_ITEM_ICON_DIVIDER}font${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.description`,
                `Background${MENU_ITEM_ICON_DIVIDER}selection-box${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.background`,
                `Divider${MENU_ITEM_ICON_DIVIDER}vertical-distribution${MENU_ITEM_ICON_DIVIDER}changeSection${MENU_ITEM_ICON_DIVIDER}${_id}.delimiter`
            ].join("||"),
            // `Add Meat to end${MENU_ITEM_ICON_DIVIDER}plus${MENU_ITEM_ICON_DIVIDER}addMeat${MENU_ITEM_ICON_DIVIDER}${_id}`,
            `Delete Section${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteSection${MENU_ITEM_ICON_DIVIDER}${_id}`,
            `${MENU_ITEM_DIVIDER}`,
            [
                `Cards layout${MENU_ITEM_ICON_DIVIDER}layout-three-columns`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}compositionCardWidget${MENU_ITEM_ICON_DIVIDER}${section.id}.${contentData.id}.${data.id}`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}carouselCardWidget${MENU_ITEM_ICON_DIVIDER}${section.id}.${contentData.id}.${data.id}`,
                `${MENU_ITEM_WIDGET}${MENU_ITEM_ICON_DIVIDER}columnCardWidget${MENU_ITEM_ICON_DIVIDER}${section.id}.${contentData.id}.${data.id}`,    
            ].join("||"),   
            `${MENU_ITEM_DIVIDER}`,     
            `${__("Change")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}changeMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`,
            `${__("Transform")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}fullscreen${MENU_ITEM_ICON_DIVIDER}transformMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`, 
            `Add Meat after this${MENU_ITEM_ICON_DIVIDER}plus${MENU_ITEM_ICON_DIVIDER}addMeat${MENU_ITEM_ICON_DIVIDER}${ section.id }.${ contentData.id }`, //
            `${__("Delete")} ${dtTitle}${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteMeat${MENU_ITEM_ICON_DIVIDER}${ contentData.id }.${ section.id }`, //
            `${MENU_ITEM_DIVIDER}`,              
            `Edit this Card${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}editCard${MENU_ITEM_ICON_DIVIDER}${section.id}.${contentData.id}.${data.id}`,
            `Delete this Card${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteCard${MENU_ITEM_ICON_DIVIDER}${section.id}.${contentData.id}.${data.id}`,
            
        ] 
        return context.join("|||")
    }

    return <div 
            className={`landing-card-container landing-card-${data.id} ${mainClass} ${animate} composition-columns-${columns}`}  
            data-card-id={data.id}
            data-card-template-id={data.id}
            context-title={ getContext() }
            ref={ref}
        >
            <CardEditForm i={ data.i } primitive={ data } items={ contentData.cards } >
                <>
                    <Shortcode  content={ data.before ? data.before : contentData.before ? contentData.before : "" } className="position-relative"/>
                    <CardBody   {...{data, section, contentData, ...props}} i={data.i} /> 
                    <CardTail   {...{data, section, contentData, ...props}} i={data.i} />
                    <CardOuter  {...{data, section, contentData, ...props}} i={data.i} />
                    <Shortcode  content={ data.after ? data.after : contentData.after ? contentData.after : "" }  className="position-relative"/>
                </>
            </CardEditForm>
        </div>
}
export default Card